import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  toggle: {
    id: 'course-authoring.sidebar.toggle-button',
    defaultMessage: 'Toggle',
    description: 'Toggle button alt',
  },
});

export default messages;
